import { lazy } from "react";

export const LazyFirmListPage = lazy(async () => ({
    default: (await import("./FirmListPage")).FirmListPage
}));

export const LazyFirmPage = lazy(async () => ({
    default: (await import("./FirmPage")).FirmPage
}));
